export const MobileDataModals = ({
  mobileResponseData,
  onClose,
  setAfterMobName,
  VerifyContinue
}) => {
  const rootData = mobileResponseData?.data || {};

  setAfterMobName(rootData?.name);

  const addresses = rootData?.address || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
        <div className='flex justify-between'>
          <h2 className="text-2xl font-bold text-blue-700 border-b">Consumer Verification Details</h2>
          <button onClick={onClose} className="text-2xl text-red-600 hover:text-red-800">❌</button>
        </div>
        {rootData?.name && (
          <div className="w-full flex flex-col items-center mb-2">
            <h3 className='text-xl text-green-600 font-semibold text-center'>Found In Experian</h3>
            {/* <Link
              to="/ExperianScore2"
              className="flex items-center bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 gap-2 rounded transition duration-300 text-sm sm:text-base"
            >
              Result Found in Experian, Check Credit details in Experian for better result
              
            </Link> */}
          </div>
        )}


        {rootData?.idspay_message && (
          <div
            className={`flex justify-center border-2 p-1 rounded-lg ${rootData?.idspay_message === 'success' ? 'bg-green-100 border-green-300' : 'bg-red-100 border-red-300'
              }`}
          >
            <p
              className={`text-md font-serif ${rootData?.idspay_message === 'success' ? 'text-green-600' : 'text-red-500'
                }`}
            >
              {rootData.idspay_message}
            </p>
          </div>
        )}

        {/* Personal Info */}
        <div className="bg-blue-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-blue-600 mb-1">Personal Info</h3>
          <div className="grid grid-cols-2 gap-1 text-sm">
            <p><strong>Full Name:</strong> {rootData?.name || "N/A"}</p>
            <p><strong>DOB:</strong> {rootData?.dob || "N/A"}</p>
            <p><strong>Gender:</strong> {rootData?.gender || "N/A"}</p>
            <p><strong>PAN:</strong> {rootData?.pan || "N/A"}</p>
            <p><strong>Email:</strong> {rootData?.email || "N/A"}</p>
          </div>
        </div>

        {/* Addresses */}
        <div className="bg-yellow-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-yellow-600 mb-2">Addresses</h3>
          {addresses.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-300 rounded-md">
                <thead className="bg-yellow-100 text-gray-700">
                  <tr>
                    <th className="border px-2 py-1 text-left">Address #</th>
                    <th className="border px-2 py-1 text-left">Full Address</th>
                    <th className="border px-2 py-1 text-left">State</th>
                    <th className="border px-2 py-1 text-left">Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => (
                    <tr key={index} className="border-t">
                      <td className="border px-2 py-1">Address {index + 1}</td>
                      <td className="border px-2 py-1">
                        {[address?.first_line_of_address, address?.second_line_of_address, address?.third_line_of_address]
                          .filter(Boolean)
                          .join(', ')}
                      </td>
                      <td className="border px-2 py-1">{address?.state || 'N/A'}</td>
                      <td className="border px-2 py-1">{address?.postal_code || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-sm">No address information available.</p>
          )}
        </div>

        {/* Footer Buttons */}
        <div className='flex justify-center gap-3 mt-3'>
          <button
            onClick={VerifyContinue}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 transition"
          >
            Verify & Continue
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};